<template>
  <div class="notification-batches">
    <ag-table :data-source-api="getAllBatches" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" />
  </div>
</template>

<script>
import utilities from "@/app/shared/utilities/index";
import AgTableBtnCell from '../../shared/shared-components/ag-grid/AgTableBtnCell';
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';

const volunteerRepo = RepositoryFactory.get('volunteerRepository');

export default {
  name: "NotificationBatches",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      channels: {
        fcm: "إشعار داخل التطبيق",
        telegram: "تيليجرام",
        whatsapp: "واتساب",
        sms: "رسالة نصية",
      },
      permissions: {
        "view-users": "volunteer_manage",
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "المعرف",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "العنوان",
          field: "title",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الوصف",
          field: "body",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "القناة",
          field: "channel",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.channels[params.data.channel] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.channels),
            valueFormatter: (params) =>
              self.channels[params.value] || params.value,
          },
        },
        {
          headerName: "عدد المستلمين",
          field: "recipientCount",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.recipientCount || "-";
          },
        },
        {
          headerName: "تاريخ الإرسال",
          field: "createdAt",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: true,
          valueGetter: function getObject(data) {
            return data.data.createdAt ? utilities.formatDate(data.data.createdAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "الإجراءات",
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            viewUsersRecord: function (batch) {
              self.$router.push({
                path: `/volunteers/notifications/${batch.id}/volunteers`,
              });
            },
            actions: ["view-users"],
            permissions: self.permissions,
          },
        },
      ];
    },
    async getAllBatches(query) {
      return await volunteerRepo.fetchNotificationBatches(`${query}&sort=createdAt,DESC`);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
